import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Field } from 'react-final-form';
/**
 * 他フォームの入力値によって Form 内の要素を出し分けするコンポーネント
 * 参考: https://codesandbox.io/s/lm4p3m92q?file=/src/index.js
 */
export const Condition = (props) => {
    const { children, is, when } = props;
    return (_jsx(Field, Object.assign({ name: when, subscription: { value: true } }, { children: ({ input: { value } }) => (is(value) ? children : null) })));
};
